// extracted by mini-css-extract-plugin
module.exports = {"container":"Marquee_container__zPdlI","wrapper":"Marquee_wrapper___q2tg","marquee":"Marquee_marquee__SKrpv"};